/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputGeoTraceCorridor } from './OutputGeoTraceCorridor';
import {
    OutputGeoTraceCorridorFromJSON,
    OutputGeoTraceCorridorFromJSONTyped,
    OutputGeoTraceCorridorToJSON,
} from './OutputGeoTraceCorridor';
import type { OutputGeoTraceHypothesis } from './OutputGeoTraceHypothesis';
import {
    OutputGeoTraceHypothesisFromJSON,
    OutputGeoTraceHypothesisFromJSONTyped,
    OutputGeoTraceHypothesisToJSON,
} from './OutputGeoTraceHypothesis';
import type { OutputGeoTraceParams } from './OutputGeoTraceParams';
import {
    OutputGeoTraceParamsFromJSON,
    OutputGeoTraceParamsFromJSONTyped,
    OutputGeoTraceParamsToJSON,
} from './OutputGeoTraceParams';
import type { OutputGeoTracePoint } from './OutputGeoTracePoint';
import {
    OutputGeoTracePointFromJSON,
    OutputGeoTracePointFromJSONTyped,
    OutputGeoTracePointToJSON,
} from './OutputGeoTracePoint';
import type { OutputGeoTraceToken } from './OutputGeoTraceToken';
import {
    OutputGeoTraceTokenFromJSON,
    OutputGeoTraceTokenFromJSONTyped,
    OutputGeoTraceTokenToJSON,
} from './OutputGeoTraceToken';

/**
 * 
 * @export
 * @interface OutputGeoTrace
 */
export interface OutputGeoTrace {
    /**
     * 
     * @type {OutputGeoTracePoint}
     * @memberof OutputGeoTrace
     */
    bootstrapLaunch?: OutputGeoTracePoint;
    /**
     * 
     * @type {OutputGeoTracePoint}
     * @memberof OutputGeoTrace
     */
    bootstrapTarget?: OutputGeoTracePoint;
    /**
     * 
     * @type {OutputGeoTraceCorridor}
     * @memberof OutputGeoTrace
     */
    corridor?: OutputGeoTraceCorridor;
    /**
     * 
     * @type {Array<OutputGeoTraceHypothesis>}
     * @memberof OutputGeoTrace
     */
    hypotheses?: Array<OutputGeoTraceHypothesis>;
    /**
     * 
     * @type {OutputGeoTraceParams}
     * @memberof OutputGeoTrace
     */
    params?: OutputGeoTraceParams;
    /**
     * 
     * @type {OutputGeoTracePoint}
     * @memberof OutputGeoTrace
     */
    staticAnchor?: OutputGeoTracePoint;
    /**
     * 
     * @type {Array<OutputGeoTraceToken>}
     * @memberof OutputGeoTrace
     */
    tokens?: Array<OutputGeoTraceToken>;
}

/**
 * Check if a given object implements the OutputGeoTrace interface.
 */
export function instanceOfOutputGeoTrace(value: object): boolean {
    return true;
}

export function OutputGeoTraceFromJSON(json: any): OutputGeoTrace {
    return OutputGeoTraceFromJSONTyped(json, false);
}

export function OutputGeoTraceFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputGeoTrace {
    if (json == null) {
        return json;
    }
    return {
        
        'bootstrapLaunch': json['bootstrapLaunch'] == null ? undefined : OutputGeoTracePointFromJSON(json['bootstrapLaunch']),
        'bootstrapTarget': json['bootstrapTarget'] == null ? undefined : OutputGeoTracePointFromJSON(json['bootstrapTarget']),
        'corridor': json['corridor'] == null ? undefined : OutputGeoTraceCorridorFromJSON(json['corridor']),
        'hypotheses': json['hypotheses'] == null ? undefined : ((json['hypotheses'] as Array<any>).map(OutputGeoTraceHypothesisFromJSON)),
        'params': json['params'] == null ? undefined : OutputGeoTraceParamsFromJSON(json['params']),
        'staticAnchor': json['staticAnchor'] == null ? undefined : OutputGeoTracePointFromJSON(json['staticAnchor']),
        'tokens': json['tokens'] == null ? undefined : ((json['tokens'] as Array<any>).map(OutputGeoTraceTokenFromJSON)),
    };
}

export function OutputGeoTraceToJSON(value?: OutputGeoTrace | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'bootstrapLaunch': OutputGeoTracePointToJSON(value['bootstrapLaunch']),
        'bootstrapTarget': OutputGeoTracePointToJSON(value['bootstrapTarget']),
        'corridor': OutputGeoTraceCorridorToJSON(value['corridor']),
        'hypotheses': value['hypotheses'] == null ? undefined : ((value['hypotheses'] as Array<any>).map(OutputGeoTraceHypothesisToJSON)),
        'params': OutputGeoTraceParamsToJSON(value['params']),
        'staticAnchor': OutputGeoTracePointToJSON(value['staticAnchor']),
        'tokens': value['tokens'] == null ? undefined : ((value['tokens'] as Array<any>).map(OutputGeoTraceTokenToJSON)),
    };
}

